import { render, staticRenderFns } from "./roomTpye.vue?vue&type=template&id=9f5dba52&scoped=true"
import script from "./roomTpye.vue?vue&type=script&lang=js"
export * from "./roomTpye.vue?vue&type=script&lang=js"
import style0 from "./roomTpye.vue?vue&type=style&index=0&id=9f5dba52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5dba52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5dba52')) {
      api.createRecord('9f5dba52', component.options)
    } else {
      api.reload('9f5dba52', component.options)
    }
    module.hot.accept("./roomTpye.vue?vue&type=template&id=9f5dba52&scoped=true", function () {
      api.rerender('9f5dba52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/roomTpye.vue"
export default component.exports